import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map } from 'rxjs';
import { APIURL } from '../shared/consts/url.const';
import {
	ActivityHistoryResponse,
	ActivityQuestionsResponse,
	ActivityResponse,
	NextActivity,
	PathResponse,
	WeekResponse
} from '../models/api/paths.model';
import { SetCorrection } from '../models/api/sets.model';

@Injectable({
	providedIn: 'root'
})
export class PathsService {
	httpClient = inject(HttpClient);

	apiUrl = APIURL;

	getPath(subjectOfferedId: number) {
		return this.httpClient.get<PathResponse>(`${this.apiUrl}/paths?subjectOfferedId=${subjectOfferedId}`);
	}

	getNextActivity(subjectOfferedId: number, weekId: number) {
		return this.httpClient.get<NextActivity>(
			`${this.apiUrl}/paths/subjectoffered/${subjectOfferedId}/week/${weekId}/nextactivity`
		);
	}

	getWeek(weekId: number) {
		return this.httpClient.get<WeekResponse>(`${this.apiUrl}/paths/week/${weekId}`);
	}

	getActivityQuestions(activityId: number) {
		return this.httpClient.get<ActivityQuestionsResponse>(`${this.apiUrl}/paths/activity/${activityId}/questions`);
	}

	getActivityHistory(activityId: number) {
		return this.httpClient.get<ActivityHistoryResponse>(`${this.apiUrl}/paths/activity/${activityId}/history`);
	}

	getChatActivity(chatActivityId: number) {
		return this.httpClient.get<ActivityResponse>(`${this.apiUrl}/paths/chatactivity/${chatActivityId}`).pipe(
			map((response) => ({
				...response,
				answers: response.answers?.map((answer) => ({
					...answer,
					id: answer.questionId
				}))
			}))
		);
	}

	getChatActivityQuestions(chatActivityId: number) {
		return this.httpClient.get<ActivityQuestionsResponse>(
			`${this.apiUrl}/paths/chatactivity/${chatActivityId}/questions`
		);
	}

	correctChatActivityQuestion(chatActivityId: number, activityItemId: number, userAnswer: string) {
		return this.httpClient.put<SetCorrection>(`${this.apiUrl}/paths/chatactivity/${chatActivityId}/correct`, {
			activityItemId: activityItemId,
			userAnswer: userAnswer
		});
	}

	closeChatActivity(chatActivityId: number) {
		return this.httpClient.post(`${this.apiUrl}/paths/chatactivity/${chatActivityId}/close`, null);
	}
}
